import React from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import Tooltip from '@components/common/tooltip/main';
import getAssetInfo from '@api/v4/private/brandfolders/bulkAssetsInfo';
import download from '@helpers/download';

import { Collection, Resource } from '@helpers/show_page_helpers';
import BulkAction from './BulkActionComponent';
import BulkAvailabilityModal from './BulkAvailabilityModal';
import BulkCollectionModal from './BulkCollectionModal';
import BulkLabelModal from './BulkLabelModal';
import BulkDeleteModal from './BulkDeleteModal';
import BulkMergeModal from './BulkMergeModal';
import BulkMoveModal from './BulkMoveModal';
import BulkShareModal from './BulkShareModal';
import BulkTagWrapper from './BulkTagWrapper';

import './styles/bulk_select_bar';

class BulkSelectBar extends React.Component {
  state = {
    activeCdnTracers: null,
    disableDownloadClick: false,
    mobileMenuExpanded: false,
    showModal: null,
    selectedAssetsData: [],
    selectedAssetTypes: new Set(),
    selectedAssetsApproved: false,
  };

  componentDidMount() {
    if ($('body').hasClass('desktop-view') || $('body').hasClass('desktop-narrow-view')) {
      this.determineBrowserWidth(); // execute on page load
      window.addEventListener('resize', this.determineBrowserWidth);
    }
  }

  componentDidUpdate(prevProps) {
    const assetsProcessingDone = this.props.assetsProcessing < prevProps.assetsProcessing;
    const selectedAssetKeysDifferent = this.props.selectedAssetKeys.size !== prevProps.selectedAssetKeys.size;
    if ((assetsProcessingDone || selectedAssetKeysDifferent) && this.props.selectedAssetKeys.size) {
      // comparing previous and current props.selectedAssetKeys.size did not behave as expected
      // componentDidUpdate did not catch a difference in previous and current
      // props.selectedAssetKeys.size on asset upload
      // so using props.assetsProcessing here to trigger this
      this.getSelectedAssetsData();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.determineBrowserWidth);
  }

  getSelectedAssetsData = () => {
    if (this.props.orgSearchPage) { return undefined; }

    const { selectedAssetKeys } = this.props;
    if (selectedAssetKeys.size > 0) {
      getAssetInfo({
        brandfolderKey: BF.fx.brandfolder().key,
        assetKeys: Array.from(selectedAssetKeys),
      }).then(({ types, assets, approved, active_cdn_tracers }) => {
        this.setState({
          selectedAssetTypes: new Set(types),
          activeCdnTracers: active_cdn_tracers,
          selectedAssetsData: assets,
          selectedAssetsApproved: approved
        });
      });
    } else {
      this.setState({
        selectedAssetsData: [],
        selectedAssetTypes: new Set(),
        selectedAssetsApproved: false,
      });
    }
    return undefined;
  }

  resetShowModal = () => {
    this.setState({ showModal: null });
  }

  determineBrowserWidth = () => {
    const $windowWidth = $(window).width();
    const $body = $('body');

    if ($windowWidth <= 935 && $body.hasClass('desktop-view')) {
      $body.removeClass('desktop-view').addClass('desktop-narrow-view');
    } else if ($windowWidth > 935 && $body.hasClass('desktop-narrow-view')) {
      $body.removeClass('desktop-narrow-view').addClass('desktop-view');
    }
  }

  viewOnly = () => (Resource.type === 'collection') && Collection.view_only;

  closeBulkSelectBar = () => {
    this.setState({ mobileMenuExpanded: false });
    this.props.addRemoveSelected([]);
  }

  renderModal = () => {
    const { activeLabelKey, addRemoveSelected, labels, selectedAssetKeys, libraryName } = this.props;
    const { selectedAssetsData, selectedAssetTypes, showModal } = this.state;

    switch (showModal) {
      case "BulkShareModal":
        return (
          <BulkShareModal
            selectedAssetKeys={selectedAssetKeys}
            resetShowModal={this.resetShowModal}
          />
        );
      case "BulkTagWrapper":
        return (
          <BulkTagWrapper
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkCollectionModal":
        return (
          <BulkCollectionModal
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkAvailabilityModal":
        return (
          <BulkAvailabilityModal
            activeCdnTracers={this.state.activeCdnTracers}
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkLabelModal":
        return (
          <BulkLabelModal
            activeLabelKey={activeLabelKey}
            addRemoveSelected={addRemoveSelected}
            closeModal={this.resetShowModal}
            labels={labels}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkDeleteModal":
        return (
          <BulkDeleteModal
            addRemoveSelected={addRemoveSelected}
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
          />
        );
      case "BulkMergeModal":
        return (
          <BulkMergeModal
            addRemoveSelected={addRemoveSelected}
            closeModal={this.resetShowModal}
            selectedAssetKeys={selectedAssetKeys}
            selectedAssetsData={selectedAssetsData}
          />
        );
      case "BulkMoveModal":
        return (
          <BulkMoveModal
            addRemoveSelected={addRemoveSelected}
            closeModal={this.resetShowModal}
            libraryName={libraryName}
            selectedAssetKeys={selectedAssetKeys}
            selectedAssetTypes={selectedAssetTypes}
            resetShowModal={this.resetShowModal}
          />
        );
      default:
        return <div />;
    }
  }

  bulkAction = (modalName, icon, copy, withText = false) => (
    <Tooltip
      tooltipId={`${copy}-tooltip`}
      className={`${copy}-tooltip-component`}
      tooltipContent={copy}
      type="light"
      offset={`{'top': -20}`}
    >
      <div
        className={`bulk-bar-item hover-item ${withText ? 'with-text' : ''}`}
        onClick={() => this.setState({ showModal: `${modalName}` })}
      >
        <span
          className={`icon ${icon}`}
          aria-hidden={withText}
          aria-label={withText ? '' : `${copy}`}
        />
        <h4 className="action-text">{copy}</h4>
      </div>
    </Tooltip>
  );

  bulkActionDownload = () => {
    const { disableDownloadClick } = this.state;
    const disabledClass = disableDownloadClick ? 'disabled-section' : '';

    return (
      <div
        className={`bulk-bar-item with-text download-action hover-item ${disabledClass} action-text`}
        onClick={() => this.bulkDownloadAssets()}
      >
        <span className="icon bff-download-asset" aria-hidden="true" />
        <h4 className="download-text action-text">{t('Download')}</h4>
        {!this.props.orgSearchPage && ( // TODO implement "download some" for org search page
          <div className="hide-touchscreen">
            <div className="download-options-container">
              <div
                className="download-container hover-item"
                onClick={(e) => {
                  e.stopPropagation();
                  BF.BulkAction.bulk_advanced_download_show(this);
                }}
              >
                <h4 className="download-actions">{t('Download Some')}</h4>
              </div>
              <div
                className={`download-container hover-item ${disabledClass}`}
                onClick={(e) => {
                  e.stopPropagation();
                  this.bulkDownloadAssets();
                }}
              >
                <h4 className="download-actions">{t('Download All')}</h4>
              </div>
              {BFG.context.hasFeature('csv_metasheets') && (
                <div
                  className={`download-container hover-item ${disabledClass}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.bulkCSVDownloadAssets();
                  }}
                >
                  <h4 className="download-actions">{t('Download CSV')}</h4>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  bulkCSVDownloadAssets = () => {
    this.setState({ disableDownloadClick: true });

    const { selectedAssetKeys } = this.props;
    const $downloadIndicator = $('.download_progress_indicator');

    $downloadIndicator.addClass('active bulk-download').css('visibility', 'visible');

    const url = `/${BF.fx.resource().slug}/assets/csv/download_assets`;
    const resourceType = BF.fx.resource().type;
    const resourceKey = BF.fx.resource().key;
    const resourceName = BF.fx.resource().name;

    $.ajax({
      url,
      type: 'POST',
      data: {
        asset_keys: Array.from(selectedAssetKeys),
        resource_type: resourceType,
        resource_key: resourceKey
      },
      context: this,
      beforeSend: (xhr) => {
        xhr.setRequestHeader('Authorization', `Bearer ${BF_Token}`);
      },
      success: (response) => {
        if (response) {
          this.setState({ disableDownloadClick: false });
          const blob = typeof File === 'function' ? new File([response], 'something.csv', { type: 'text/csv' }) : new Blob([response], { type: 'text/csv' });
          const URL = window.URL || window.webkitURL;
          const downloadUrl = URL.createObjectURL(blob);

          download(downloadUrl, { filename: `${resourceName}-assets.csv`, filetype: 'text/csv' });
          setTimeout(() => {
            $downloadIndicator.css('visibility', 'hidden').removeClass('active bulk-download');
          }, 1000);
          Notify.create({
            title: `${t('Downloaded')}`,
            type: "success"
          });
        }
      }
    });
  }

  bulkDownloadAssets = () => {
    this.setState({ disableDownloadClick: true });

    const { selectedAssetKeys } = this.props;
    const $downloadIndicator = $('.download_progress_indicator');

    // overriding default translation to get above bulk select bar by adding class 'bulk-download'
    $downloadIndicator.addClass('active bulk-download').css('visibility', 'visible');

    const url = BF_Manifest
      ? `/api/v3/share_manifests/${BF_Manifest}/assets/download`
      : "/api/v3/assets/download";

    $.ajax({
      url,
      type: 'POST',
      data: { asset_keys: Array.from(selectedAssetKeys) },
      context: this,
      beforeSend: (xhr) => { xhr.setRequestHeader('Authorization', `Bearer ${BF_Token}`); },
      success: (response) => {
        this.setState({ disableDownloadClick: false });
        if (response.data && !!response.data.redirect_url) {
          window.location.href = response.data.redirect_url;
          setTimeout(() => {
            $downloadIndicator.css('visibility', 'hidden').removeClass('active bulk-download');
          }, 1000);
          const fileCount = parseInt(response.data.attachment_count || response.data.total_count, 10);
          const fileCopy = fileCount === 1 ? t('asset') : t('assets');
          Notify.create({
            title: `${t('Downloaded')} ${fileCount} ${fileCopy}`,
            type: "success"
          });
        } else {
          BF.BulkAction.result_poller(url.replace('download', 'bulk-convert-download-poller'), response.data, 500);
        }
      },
      error: () => {
        this.setState({ disableDownloadClick: false });
        Notify.create({
          title: t('Something went wrong. Try again soon!'),
          type: 'error'
        });
        $downloadIndicator.css('visibility', 'hidden').removeClass('active bulk-download');
      },
      complete: () => {
        // Create asset download events
        selectedAssetKeys.forEach((assetKey) => {
          Insight.createEvent('downloaded', assetKey, 'asset');
        });
      }
    });
  }

  bulkActionComponent(actionType) {
    const { selectedAssetKeys, approver, addRemoveSelected } = this.props;
    const { activeCdnTracers, selectedAssetsApproved } = this.state;

    return (
      <BulkAction
        selectedAssetKeys={selectedAssetKeys}
        assetsApproved={selectedAssetsApproved}
        resetShowModal={this.resetShowModal}
        addRemoveSelected={addRemoveSelected}
        approver={approver}
        actionType={actionType}
        activeCdnTracers={activeCdnTracers}
      />
    );
  }

  renderBulkSelectActions() {
    const {
      selectAll,
      selectedAssetKeys,
      totalAssets,
    } = this.props;
    const allClass = selectedAssetKeys.size === totalAssets ? 'all-selected' : '';

    return (
      <div className="select-actions-container">
        <div className="bulk-bar-item select-qty">
          <h4 className="select-text-faded">{`${selectedAssetKeys.size} `} {t('selected')}</h4>
        </div>
        <div className="bulk-bar-item select-title">
          <h4 className="select-text-faded">{t('Select:')}</h4>
        </div>
        <div
          className={`bulk-bar-item hover-item select-all ${allClass}`}
          onClick={() => selectAll()}
        >
          <h4 className="select-text">{t('All')}</h4>
        </div>
        <div
          className="bulk-bar-item hover-item select-none"
          onClick={() => this.closeBulkSelectBar()}
        >
          <h4 className="select-text">{t('None')}</h4>
        </div>
      </div>
    );
  }

  renderBulkActionToolbar() {
    const { activeLabelKey, approver, editable, selectedAssetKeys } = this.props;
    const { selectedAssetTypes } = this.state;
    const onlyGenericFiles = selectedAssetTypes.size === 1 && selectedAssetTypes.has('GenericFile');
    const mobileClassMenu = this.state.mobileMenuExpanded ? 'mobile-expanded' : '';
    const mobileMenuPromptClass = this.state.mobileMenuExpanded ? 'mobile-prompt-hidden' : '';
    /* eslint-disable no-nested-ternary, no-undef */
    return (
      <div className={`bulk-actions-bar active ${mobileClassMenu}`}>
        <div className={`mobile-expand-prompt hide-desktop ${mobileMenuPromptClass}`}>
          { this.renderBulkSelectActions() }
          <div
            className="view-bulk-select-bar hover-item"
            onClick={() => this.setState((prevState) => ({ mobileMenuExpanded: !prevState.mobileMenuExpanded }))}
          >
            <span className="bff-ellipses icon" />
            <h4 className="action-text">{t('View Options')}</h4>
          </div>
        </div>

        { this.renderBulkSelectActions() }
        <div className="bulk-actions-container">
          {(editable && approver && BFG.context.hasFeature('asset_approvals')) ? this.bulkActionComponent('BulkApproval') : null}
          {(editable && !Collection.key && BFG.context.hasFeature('asset_availability')) ? this.bulkAction('BulkAvailabilityModal', 'bff-clock', 'Schedule Availability') : null}
          {(editable && !Collection.key && selectedAssetTypes.size === 1) ? this.bulkAction('BulkMoveModal', 'bff-move', 'Move') : null}
          {(editable && !Collection.key && activeLabelKey) ? this.bulkAction('BulkLabelModal', 'bff-label', 'Remove Label') : null}
          {(editable && !Collection.key) ? this.bulkAction('BulkDeleteModal', 'bff-trash', 'Delete') : null}
          {(editable) ? this.bulkAction('BulkTagWrapper', 'bff-tag', 'Tag', true) : null }
          {(editable && selectedAssetKeys.size > 1 && selectedAssetKeys.size < 50 && onlyGenericFiles) ? this.bulkAction('BulkMergeModal', 'bff-merge', 'Merge', true) : null}
          {(editable && Collection.key) ? this.bulkActionComponent('BulkCollectionRemoval') : null}
          {(editable && !Collection.key) ? this.bulkAction('BulkCollectionModal', 'bff-plus', 'Collection', true) : null}
          {(BFG.context.hasFeature('share_links') && !BFG.manifestDigest && (editable || !this.viewOnly())) ? this.bulkAction('BulkShareModal', 'bff-share', 'Share', true) : null}
          {(editable || !this.viewOnly()) ? this.bulkActionDownload() : null}
        </div>
        <div
          className="close-container hover-item hide-touchscreen"
          onClick={() => this.closeBulkSelectBar()}
        >
          <span className="bff-close icon" />
          <h4 className="hide-desktop close-text">{t('Deselect All & Close')}</h4>
        </div>
        <div
          className="close-container hover-item hide-desktop"
          onClick={() => this.setState((prevState) => ({ mobileMenuExpanded: !prevState.mobileMenuExpanded }))}
        >
          <h4 className="hide-desktop close-text">{t('Hide')}</h4>
        </div>
      </div>
    );
    /* eslint-enable no-nested-ternary, no-undef */
  }

  render() {
    return (
      <div>
        {this.renderModal()}
        {this.props.selectedAssetKeys.size > 0
          ? this.renderBulkActionToolbar()
          : <div className="bulk-actions-bar" />}
      </div>
    );
  }
}

BulkSelectBar.propTypes = {
  activeLabelKey: PropTypes.string,
  addRemoveSelected: PropTypes.func.isRequired,
  approver: PropTypes.bool.isRequired,
  assetsProcessing: PropTypes.number,
  editable: PropTypes.bool.isRequired,
  labels: PropTypes.shape({}),
  libraryName: PropTypes.string,
  orgSearchPage: PropTypes.bool,
  selectAll: PropTypes.func.isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
  totalAssets: PropTypes.number.isRequired,
};

BulkSelectBar.defaultProps = {
  activeLabelKey: null,
  assetsProcessing: 0,
  labels: {},
  libraryName: "Brandfolder",
  orgSearchPage: false,
};

export default BulkSelectBar;
